import './introblock.less'

import {m} from '@codeurs/front'
import {FunctionComponent} from 'react'
import {style} from 'util/style'
import {Theme} from 'views/theme'
import {Block} from './blocks'

export type IntroBlockType = {
	text: string
}

const styles = style('introblock')

export const IntroBlock: FunctionComponent<IntroBlockType> = ({text}) => {
	if (!text) return

	return (
		<Block class={styles}>
			<Theme.Wysiwyg>{text}</Theme.Wysiwyg>
		</Block>
	)
}
